// API Keys Configuration
// In production, you should use environment variables instead of storing API keys in code

export const OPEN_WEATHER_API_KEY = 'c90ef964424f2dc28a970132ccc85808'; 
// Replace with your actual OpenWeatherMap API key from https://openweathermap.org/api

// API Base URLs
// Use localhost in development, production URL in production
const isDevelopment = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
export const API_BASE_URL = process.env.REACT_APP_API_URL || (isDevelopment ? 'https://api.agromanch.com' : 'https://api.agromanch.com');
export const LOCAL_API_URL = isDevelopment ? 'https://api.agromanch.com' : 'https://api.agromanch.com';

// Geoapify API Key for location services
export const GEOAPIFY_API_KEY = '66fb211605ce4df19efc87571b04001a';

// Cloudinary Configuration
export const CLOUDINARY_CLOUD_NAME = 'dlpjayfhf';
export const CLOUDINARY_UPLOAD_PRESET = 'ml_default'; 
